import React, { useRef, useEffect } from 'react'
import { useMergeState } from '../../../irmlib/src/hooks'
import Table from '../Table'
import { useLocation } from 'react-router-dom'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import moment from 'moment'
import PropTypes from 'prop-types'

const initialSate = {
  showTable: false,
  boxes: [],
  jobDoc: ''
}

const BoxesTable = (props) => {
  const [, setState] = useMergeState(initialSate)
  const tableRef = useRef(null)
  const location = useLocation()
  const JobId = location.pathname.split('/')[2]

  useEffect(() => {
    tableRef.current.dataManager.changeSearchText(props.DataSearch)
    tableRef.current.setState(tableRef.current.dataManager.getRenderState())
  }, [props])

  // const getUser = async (userId) => {
  //   const workerDoc = await gdeTransactions.getWorkerDetails(userId)
  //   console.log(`${workerDoc.data().firstName}' '${workerDoc.data().lastName}`)
  //   return (`${workerDoc.data().firstName}' '${workerDoc.data().lastName}`)
  // }

  // const getFileCount = async (jobId, boxId) => {
  //   const files = await gdeTransactions.getFilesForBox(jobId, boxId)
  //   console.log(typeof (files.size))
  //   return `${files.size}`
  // }

  const getBoxes = async () => {
    const collection = await gdeTransactions.getBoxesForJob(JobId)
    const boxList = []
    collection.forEach((doc) => {
      boxList.push({ 
        SKP_Box_ID: doc.id,
        Date_Submitted: moment(doc.data().actionTs.toDate()).format('DD/MM/YYYY'),
        // Entry_User: getUser(doc.data().dataEntryUser),
        // No_of_Files: getFileCount(JobId, doc.id), // check
        Status: doc.data().status,
        Status1: doc.data().status,
      })
    })
    setState({ boxes: boxList })
    return boxList
  }

  return (
    // <TableContainer>
    //   <FlexByRow>
    //     <HalfScreen>
    //     </HalfScreen>
    //     <HalfScreen>
    //     </HalfScreen>
    //   </FlexByRow>
    //   <VerticalDivider />
    <Table
      title={''}
      tableRef={props.tableRef ? props.tableRef : tableRef}
      refresh={props.refresh}
      totalRecords={200}
      columns={props.columns}
      getPageData={props.getPageData ? props.getPageData : getBoxes}
      data={props.getPageData}
      rowsPerPageOptions={[2]}
      exportButton={false}
      paging={true}
      draggable={false}
      search={false}
      backgroundColor={'default'}
      sorting={true}
      onSelectionChange={props.selection ? props.onSelectionChange : null}
      selection={!!props.selection}
    />
    // </TableContainer>

     
  )
}
BoxesTable.propTypes = {
  columns: PropTypes.array,
  getPageData: PropTypes.func,
  onSelectionChange: PropTypes.func,
  selection: PropTypes.bool,
  refresh: PropTypes.bool,
  tableRef: PropTypes.any,
  DataSearch: PropTypes.any
}

export default BoxesTable